import React from "react";
import {Row, Col} from "react-bootstrap";
import {ReactHighcharts} from "../../../lib/react-highcharts";
import StatisticTable from "./StatisticTable";

const UnknownLabel = "Не определено";

ReactHighcharts.Highcharts.setOptions({
	global: {
		useUTC: false
	}
});

class StatisticPieTable extends React.Component {

	render() {
		const chartDataLimit = 5;
		const props = this.props;
		const data = props.data;

		const chartData = data.slice(0, chartDataLimit);
		if(data.length > chartDataLimit) {
			chartData.push({
				name: 'Остальные',
				count: data.slice(chartDataLimit).reduce((last, cur) => last + parseInt(cur.count), 0)
			});
		}

		const chartConfig = {
			credits: {enabled: false},
			chart: {width: 240, height: 240, spacing: [0, 0, 0, 0]},
			title: {text: ''},
			plotOptions: {
				pie: {
					cursor: 'pointer',
					dataLabels: {enabled: false},
					showInLegend: true
				}
			},
			legend: {
				enabled: false
				//align: 'left',
				//verticalAlign: 'middle',
				//layout: 'vertical',
				//padding: 0,
				//itemMarginTop: 10,
				//itemMarginBottom: 10,
				//itemWidth: 150
			},
			series: [{
				type: 'pie',
				name: 'Зрителей',
				data: chartData.map(item => [item.name || UnknownLabel, parseInt(item.count)])
			}]
		};

		return (
			<Row>
				<Col sm={3}>
					<ReactHighcharts config={chartConfig}/>
				</Col>
				<Col sm={9}>
					<StatisticTable {...props} />
				</Col>
			</Row>
		);
	}
}

export default StatisticPieTable;
